import { render, staticRenderFns } from "./fieldTrialVideo.vue?vue&type=template&id=ff10c792&scoped=true"
import script from "./fieldTrialVideo.vue?vue&type=script&lang=js"
export * from "./fieldTrialVideo.vue?vue&type=script&lang=js"
import style0 from "./fieldTrialVideo.vue?vue&type=style&index=0&id=ff10c792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff10c792",
  null
  
)

export default component.exports